"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var GoogleLogo = function GoogleLogo(_ref) {
  var badge = _ref.badge,
      className = _ref.className,
      dimensions = _ref.dimensions;

  var getDimensionsStyleOverrides = function getDimensionsStyleOverrides() {
    var BADGE_PADDING_RATIO = 0.2;
    var BADGE_LOGO_DIMENSIONS_RATIO = 1 - BADGE_PADDING_RATIO * 2;
    var wrapperStyle = {};
    var svgDimensions = dimensions;

    if (badge) {
      svgDimensions = dimensions * BADGE_LOGO_DIMENSIONS_RATIO;
      wrapperStyle = {
        padding: dimensions * BADGE_PADDING_RATIO + "px",
        borderRadius: dimensions + "px"
      };
    }

    return {
      svgDimensions: svgDimensions + "px",
      wrapperStyle: wrapperStyle
    };
  };

  var WRAPPER_CLASS_NAME = 'z-google-g-logo';
  var BADGE_MODIFIER_CLASS_NAME = 'z-google-g-logo_badge';

  var _getDimensionsStyleOv = getDimensionsStyleOverrides(),
      svgDimensions = _getDimensionsStyleOv.svgDimensions,
      wrapperStyle = _getDimensionsStyleOv.wrapperStyle;

  var wrapperClasses = (0, _classnames["default"])(WRAPPER_CLASS_NAME, (0, _defineProperty2["default"])({}, BADGE_MODIFIER_CLASS_NAME, badge), className);
  return _react["default"].createElement("div", {
    className: wrapperClasses,
    style: wrapperStyle
  }, _react["default"].createElement("svg", {
    width: svgDimensions,
    height: svgDimensions,
    viewBox: "0 0 18 18",
    version: "1.1"
  }, _react["default"].createElement("g", {
    className: "symbols",
    fill: "none",
    fillRule: "evenodd"
  }, _react["default"].createElement("g", {
    className: "super-g"
  }, _react["default"].createElement("path", {
    d: "M9,3.48 C10.69,3.48 11.83,4.21 12.48,4.82 L15.02,2.34 C13.46,0.89 11.43,0 9,0 C5.48,0 2.44,2.02 0.96,4.96 L3.87,7.22 C4.6,5.05 6.62,3.48 9,3.48 L9,3.48 Z",
    fill: "#EA4335"
  }), _react["default"].createElement("path", {
    d: "M17.64,9.2 C17.64,8.46 17.58,7.92 17.45,7.36 L9,7.36 L9,10.7 L13.96,10.7 C13.86,11.53 13.32,12.78 12.12,13.62 L14.96,15.82 C16.66,14.25 17.64,11.94 17.64,9.2 L17.64,9.2 Z",
    fill: "#4285F4"
  }), _react["default"].createElement("path", {
    d: "M3.88,10.78 C3.69,10.22 3.58,9.62 3.58,9 C3.58,8.38 3.69,7.78 3.87,7.22 L0.96,4.96 C0.35,6.18 0,7.55 0,9 C0,10.45 0.35,11.82 0.96,13.04 L3.88,10.78 L3.88,10.78 Z",
    fill: "#FBBC05"
  }), _react["default"].createElement("path", {
    d: "M9,18 C11.43,18 13.47,17.2 14.96,15.82 L12.12,13.62 C11.36,14.15 10.34,14.52 9,14.52 C6.62,14.52 4.6,12.95 3.88,10.78 L0.97,13.04 C2.45,15.98 5.48,18 9,18 L9,18 Z",
    fill: "#34A853"
  }), _react["default"].createElement("polygon", {
    points: "0 0 18 0 18 18 0 18"
  })))));
};

GoogleLogo.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * adds a #CCC circular border around the logo.
   */
  badge: _propTypes["default"].bool,

  /**
   * additional classes
   */
  className: _propTypes["default"].string,

  /**
   * width/height of the logo or badge. If badge === true then the logo takes
   * up 60% of w/h
   */
  dimensions: _propTypes["default"].number
} : {};
GoogleLogo.defaultProps = {
  dimensions: 18,
  badge: false
};
var _default = GoogleLogo;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@zillow/react-zsg/GoogleLogo/index.js
// module id = 499
// module chunks = 0